const BASE_URL = 'https://api.dataforseo.com';
const SERP_ENDPOINT = `${BASE_URL}/v3/serp/google/organic/live/advanced`;
const VOLUME_ENDPOINT = `${BASE_URL}/v3/keywords_data/google_ads/search_volume/live`;

const normalizeUrl = (url) => {
  try {
    const u = url.startsWith('http') ? url : `https://${url}`;
    return new URL(u).hostname.replace(/^www\./, '');
  } catch {
    return url.replace(/https?:\/\//, '').replace(/^www\./, '').split('/')[0];
  }
};

const apiPost = async (endpoint, payload, credentials) => {
  const res = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Authorization': `Basic ${credentials}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`HTTP ${res.status}: ${text.substring(0, 300)}`);
  }

  return res.json();
};

export const checkKeywordPosition = async (keyword, url, login, password) => {
  if (!login || !password) {
    return {
      error: true,
      errorMessage: 'Credențiale API lipsă. Adaugă Login și Password în Setări.',
    };
  }

  const credentials = btoa(`${login}:${password}`);
  const domain = normalizeUrl(url);

  // ── 1. SERP ──────────────────────────────────────────────────────────────
  let position = null;

  try {
    const serpData = await apiPost(
      SERP_ENDPOINT,
      [{
        keyword,
        location_code: 2642,
        language_code: 'ro',
        device: 'desktop',
        os: 'windows',
        depth: 100,
      }],
      credentials
    );

    const task = serpData?.tasks?.[0];

    if (!task || task.status_code !== 20000) {
      return {
        error: true,
        errorMessage: `SERP error [${task?.status_code}]: ${task?.status_message || 'Unknown error'}`,
      };
    }

    const items = task?.result?.[0]?.items || [];
    const found = items.find(
      (item) =>
        item.type === 'organic' &&
        item.url &&
        normalizeUrl(item.url).includes(domain)
    );

    position = found ? (found.rank_absolute ?? found.rank_group) : null;

  } catch (err) {
    return {
      error: true,
      errorMessage: `SERP request failed: ${err.message}`,
    };
  }

  // ── 2. Search Volume ──────────────────────────────────────────────────────
  let searchVolume = null;

  try {
    const volData = await apiPost(
      VOLUME_ENDPOINT,
      [{
        keywords: [keyword],
        location_code: 2642,
        language_code: 'ro',
      }],
      credentials
    );

    const volTask = volData?.tasks?.[0];
    if (volTask?.status_code === 20000) {
      searchVolume = volTask?.result?.[0]?.search_volume ?? null;
    }
  } catch (err) {
    console.warn('[API] Volume call failed (non-critical):', err.message);
  }

  return {
    position,
    searchVolume,
    notFound: position === null,
    error: false,
  };
};